// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"f06ae59b","86":"c7355821","384":"8d1a0aad","915":"c7355821"}[chunkId] + ".chunk.css";
};